<template>
    <div class="container">
        <div v-if="showList" style="width: 1600px">
            <listPage @showForm="showForm" :params="form"></listPage>
        </div>
        <div v-else style="width: 1300px">
            <div class="top-section">
                <div class="section-label">
                    <div class="zh">形状</div>
                    <div class="en">Shape</div>
                </div>
                <div class="section">
                    <div :class="['shape-box', form.shape===shape.name ? 'shape-box-selected' : '' ]"
                         v-for="(shape, shapeKey) in shapes"
                         @click="chooseFeature('shape', shape.name)">
                        <div class="icon">
                            <i :class="['iconfont', shape.shape]"></i>
                        </div>
                        <div class="shape-name">
                            {{ shape.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex;flex-wrap: wrap;">
                <div class="box box-left">
                    <div class="section-label">
                        <div class="zh">钻重</div>
                        <div class="en">Weight</div>
                    </div>
                    <div class="section">
                        <div class="weight-list flex-center">
                            <div v-for="(weight, weightKey) in weights"
                                 :class="['weight', 'btn-s', ((form.weight_from*1===weight.from*1&&form.weight_to*1===weight.to*1)?'btn-selected':'')]"
                                 @click="chooseWeight(weight)">
                                {{ weight.from }}-{{ weight.to }}
                            </div>
                        </div>
                        <div class="slider">
                            <el-slider
                                v-model="form.weight"
                                range
                                @change="onChange"
                                :step="0.01"
                                :min="0.01"
                                :max="20">
                            </el-slider>
                        </div>
                        <div class="weight-form flex-center">
                            <div class="weight-form-item">
                                <input type="number" step="0.01" class="weight-value" v-model="form.weight_from" id="from" @blur="checkWeight">
                                <span class="unit">ct</span>
                            </div>
                            <div class="weight-form-item" style="margin-left: auto;">
                                <span class="unit" style="left: 88px;">ct</span>
                                <input type="number" step="0.01" class="weight-value" v-model="form.weight_to" id="to" @blur="checkWeight">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box box-right">
                    <div class="section-label">
                        <div class="zh">切工</div>
                        <div class="en">Cut</div>
                    </div>
                    <div class="section">
                        <div class="shortcut">
                            <div :class="isQuickChosen(0)?'qs':''" @click="quickChoose(0)">3EX</div>
                            <div class="separator"></div>
                            <div :class="isQuickChosen(1)?'qs':''" @click="quickChoose(1)">3VG</div>
                        </div>
                        <div style="width: 100%; margin-top: 10px">
                            <div v-for="(cutType, cutTypeKey) in cutTypes" style="margin-top: 10px" class="flex-center">
                                <div class="cut-label">{{ cutType.label }}</div>
                                <div v-for="(cutQuality, cutQualityKey) in cutQualityList"
                                     @click="chooseFeature(cutType.name, cutQuality.name)"
                                     :class="['btn', 'cutQuality', form[cutType.name]===cutQuality.name?'btn-selected':'']">
                                    {{ cutQuality.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box box-left">
                    <div class="section-label">
                        <div class="zh">颜色</div>
                        <div class="en">Color</div>
                    </div>
                    <div class="section">
                        <div class="color">
                            <div v-for="(color, colorKey) in colors"
                                 @click="chooseFeature('color', color.name)"
                                 :class="['btn', form.color===color.name?'btn-selected':'']">
                                {{ color.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box box-right">
                    <div class="section-label">
                        <div class="zh">净度</div>
                        <div class="en">Clarity</div>
                    </div>
                    <div class="section">
                        <div class="clarity">
                            <div v-for="(clarity, clarityKey) in clarityList"
                                 @click="chooseFeature('clarity', clarity.name)"
                                 :class="['btn', form.clarity===clarity.name?'btn-selected':'']">
                                {{ clarity.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box box-left">
                    <div class="section-label">
                        <div class="zh">荧光</div>
                        <div class="en">Fluorescence</div>
                    </div>
                    <div class="section">
                        <div v-for="(florescence, florescenceKey) in florescenceList"
                             @click="chooseFeature('fls', florescence.name)"
                             :class="['btn', form.fls===florescence.name?'btn-selected':'']">
                            {{ florescence.name }}
                        </div>
                    </div>
                </div>
                <div class="box box-right">
                    <div class="section-label">
                        <div class="zh">奶咖色</div>
                        <div class="en">Clouds</div>
                    </div>
                    <div class="section">
                        <div v-for="(cream, creamKey) in creamTypes"
                             @click="chooseFeature('cream', cream.name)"
                             :class="['btn', form.cream===cream.name?'btn-selected':'']">
                            {{ cream.name }}
                        </div>
                        <div style="height: 100%;width: 20px"></div>
                        <div v-for="(coffee, coffeeKey) in coffeeTypes"
                             @click="chooseFeature('coffee', coffee.name)"
                             :class="['btn', form.coffee===coffee.name?'btn-selected':'']">
                            {{ coffee.name }}
                        </div>
                    </div>
                </div>
                <div class="box box-left">
                    <div class="section-label">
                        <div class="zh">证书</div>
                        <div class="en">Certificate</div>
                    </div>
                    <div class="section">
                        <div v-for="(certificate, certificateKey) in certificateTypes"
                             @click="chooseFeature('type', certificate.name)"
                             :class="['btn', form.type===certificate.name?'btn-selected':'']">
                            {{ certificate.name }}
                        </div>
                    </div>
                </div>
                <div class="box box-right">
                    <div class="section-label">
                        <div class="zh">位置</div>
                        <div class="en">Position</div>
                    </div>
                    <div class="section">
                        <div v-for="(location, locationKey) in locations"
                             @click="chooseFeature('position', location.name)"
                             :class="['btn', form.position===location.name?'btn-selected':'']">
                            {{ location.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="operations">
                <div class="submit reset" @click="resetForm">重置参数</div>
                <div class="submit query" @click="showDiamondList">裸钻查询</div>
            </div>
        </div>
    </div>
</template>

<script>
import {diamondList} from '@/api/api';
import listPage from './diamondList'

export default {
    components: { listPage },
    data() {
        return {
            locations: [
                {name: '香港'},
                {name: '国内'},
                {name: '国外'}
            ],
            certificateTypes: [
                {name: 'NGTC'},
                {name: 'GIA'}
            ],
            creamTypes: [
                {name: '不奶'},
                {name: '带奶'}
            ],
            coffeeTypes: [
                {name: '不咖'},
                {name: '带咖'}
            ],
            florescenceList: [
                {name: 'N'},
                {name: 'F'},
                {name: 'M'},
                {name: 'S'},
                {name: 'VS'}
            ],
            clarityList: [
                {name: 'FL'},
                {name: 'IF'},
                {name: 'VVS1'},
                {name: 'VVS2'},
                {name: 'VS1'},
                {name: 'VS2'},
                {name: 'SI1'},
                {name: 'SI2'}
            ],
            cutQualityList: [
                {name: 'EX'},
                {name: 'VG'},
                {name: 'GD'}
            ],
            cutTypes: [
                {name: 'cut', label: '打磨'},
                {name: 'polish', label: '抛光'},
                {name: 'symm', label: '对称'}
            ],
            shapes: [
                {
                    shape: 'icon-round3-01',
                    name: '圆形'
                }, {
                    shape: 'icon-OVAL-01',
                    name: '椭圆形'
                }, {
                    shape: 'icon-CUSHION-01',
                    name: '垫形'
                }, {
                    shape: 'icon-ASSCHER-01',
                    name: '阿斯切'
                }, {
                    shape: 'icon-RADIANT-01',
                    name: '雷迪恩'
                }, {
                    shape: 'icon-EMERALD-01-01',
                    name: '祖母绿'
                }, {
                    shape: 'icon-PRINCESS-01',
                    name: '公主方'
                }, {
                    shape: 'icon-MARQUISE',
                    name: '马眼形'
                }, {
                    shape: 'icon-PEAR-01',
                    name: '梨形'
                }, {
                    shape: 'icon-HEART-01',
                    name: '心形'
                }],
            weights: [
                {
                    from: '0.30',
                    to: '3.5'
                }, {
                    from: '3.51',
                    to: '6.0'
                }, {
                    from: '6.01',
                    to: '9.0'
                }, {
                    from: '9.01',
                    to: '12.0'
                }, {
                    from: '12.01',
                    to: '17.0'
                }, {
                    from: '17.01',
                    to: '20.0'
                }
            ],
            colors: [
                {name: 'D'},
                {name: 'E'},
                {name: 'F'},
                {name: 'G'},
                {name: 'H'},
                {name: 'I'},
                {name: 'J'},
                {name: 'K'},
                {name: 'L'},
                {name: 'M'},
                {name: 'N'},
            ],
            selectedShape: {},

            showList: false,
            errMsg: '',
            form: {}
        }
    },
    beforeMount() {
        this.resetForm()
    },
    methods: {
        showForm(){
            this.showList = false
        },
        showDiamondList(){
            this.showList = true
        },
        resetForm(){
            this.form = {
                weight: [2.01, 5.0],
                weight_from: '2.01',
                weight_to: '5.0',
                position: '', // 位置
                page: 1,
                per_page: 20,
                shape: '',
                direction: '',
                sort: '',
                color: '',
                clarity: '',
                cut: '', // 打磨
                polish: '', // 抛光
                symm: '', // 对称
                fls: '', // 荧光
                type: '', // 类型
                cream: '', // 奶色
                coffee: '', // 咖色
            }
        },
        isQuickChosen(key) {
            for (const cutType of this.cutTypes) {
                if (this.form[cutType.name] !== this.cutQualityList[key].name) {
                    return false
                }
            }
            return true
        },
        quickChoose(key) {
            for (const cutType of this.cutTypes) {
                this.form[cutType.name] = this.cutQualityList[key].name
            }
        },
        checkWeight() {
            let from = this.form.weight_from * 1
            let to = this.form.weight_to * 1
            console.log(from, to)
            if (from > to) {
                from = to
                this.$message.error('起始重量不得大于结束重量')
            }
            if (from <= 0.03) {
                this.$message.error('最小重量不得小于0.03ct')
                from = 0.03
            }
            if (to >= 20) {
                this.$message.error('最大重量不得超过20ct')
                to = 20
            }
            this.form.weight_from = (from).toFixed(2)
            this.form.weight_to = (to).toFixed(2)
            this.form.weight = [from, to]
        },
        onChange(value) {
            this.form.weight_from = value[0]
            this.form.weight_to = value[1]

        },
        chooseWeight(weight) {
            this.form.weight_from = (weight.from * 1).toFixed(2)
            this.form.weight_to = (weight.to * 1).toFixed(2)
            this.form.weight = [weight.from, weight.to]
        },

        chooseFeature(name, value) {
            /* 多条件
            let index = this.form[name].findIndex(e=>e===value)
            console.log(index)
            if ( -1 === index ) {
                this.form[name].push(value)
            } else {
                this.form[name].splice(index, 1)
            }*/

            if (this.form[name] === value) {
                this.form[name] = ''
            } else {
                this.form[name] = value
            }
        },
    },
    watch: {

    }
}
</script>

<style lang="scss">
@import "NewCalculator";
</style>